import React, {forwardRef, useEffect, useRef, useState} from "react";
import MdEditor from 'for-editor'
import {ipcInvoke} from "../../../../../src/common/ipc";
import {KEY_FILE_DIR} from "../../../../../src/Const";
import './MyMdEditor.css'
import Global from "../../../../../src/global";

const MyMdEditor = forwardRef((props:{element:any,isActive:any,appState:any,onMouseDown:any,onMouseMove:any,onMouseUp:any,onWheel:any}, ref)=>{

    /** 默认工具栏按钮全部开启, 传入自定义对象
     例如: {
     h1: true, // h1
     code: true, // 代码块
     preview: true, // 预览
     }
     此时, 工具栏只显示此三个功能键（注：传入空对象则不显示工具栏）
     */
        // 工具栏菜单
    const toolbar = {
            h1: true, // h1
            h2: true, // h2
            h3: true, // h3
            h4: true, // h4
            img: true, // 图片
            link: true, // 链接
            code: true, // 代码块
            preview: true, // 预览
            expand: false, // 全屏
            /* v0.0.9 */
            undo: true, // 撤销
            redo: true, // 重做
            save: true, // 保存
            /* v0.2.3 */
            subfield: true, // 单双栏模式
        };

    // 保存Markdown文本内容
    const [mdContent, setMdContent] = useState('');
    const mTimeoutId = useRef<any>(0);

    useEffect(() => {
        //读取这个文件，然后设置...
        let szFileDir = localStorage.getItem(KEY_FILE_DIR);
        let szFilePath = props.element.customData.generationData.fileName;
        if (!props.element.customData.generationData.isAbsolutePath){
            szFilePath = szFileDir + szFilePath;
        }
        ipcInvoke('read-file-absolute-path-text',{filePath:szFilePath})?.then(res=>{
            setMdContent(res);
        })

        window.refreshList['onUpdateMdContent_'+props.element.id] = onUpdateMdContent;

        return ()=>{
            delete window.refreshList['onUpdateMdContent_'+props.element.id];
        }
    }, [props.element]);

    useEffect(() => {
        if (props.isActive){
            setTimeout(()=>{
                const div = document.getElementById(`excalidraw__iframe__outer${props.element.id}`);
                if (div){
                    const txt = div.getElementsByTagName('textarea');
                    if (txt && txt.length > 0){
                        txt[0].focus();
                    }
                }
            },100)
        }
    }, [props.isActive]);

    /**
     * 刷新md内容
     * @param szContent
     */
    function onUpdateMdContent(szContent:any){
        setMdContent(szContent)
    }


    // 输入内容改变
    function handleEditorChange (value) {
        setMdContent(value);
        clearTimeout(mTimeoutId.current);
        //读取这个文件，然后设置...
        let szFileDir = localStorage.getItem(KEY_FILE_DIR);
        let szFilePath = props.element.customData.generationData.fileName;
        if (!props.element.customData.generationData.isAbsolutePath){
            szFilePath = szFileDir + szFilePath;
        }
        //这里记录---
        Global.g_mapMdContentCache[props.element.id] = value;

        mTimeoutId.current = setTimeout(()=>{
            //保存...
            ipcInvoke('write-file-absolute-path-text',{filePath:szFilePath,data:value});
        },1600);
    }
    // 保存输入内容
    function handleEditorSave (value) {
        console.log('handleEditorSave', value);
    }

    return <div style={{width:'100%',height:'100%'}} onMouseDown={props.onMouseDown} onMouseMove={props.onMouseMove} onMouseUp={props.onMouseUp} onWheel={(event)=>{
        if (document.activeElement?.tagName != 'TEXTAREA'){
            props.onWheel(event);
        }
    }}>
        <MdEditor placeholder={''} toolbar={toolbar} value={mdContent} lineNum={0}
                  onChange={handleEditorChange} preview={props.element.customData?.generationData?.isSplitView} subfield={props.element.customData?.generationData?.isSplitView} onSave={handleEditorSave}/>
    </div>
})

export default MyMdEditor;















